/**
 * Integration module constants
 * Centralizes all hardcoded values for better maintainability and type safety
 */

export enum PartnerName {
  LIGHTSPEED = 'LIGHTSPEED'
}

export const PARTNER_SLUGS = {
  LIGHTSPEED: 'lightspeed-pos'
} as const

export const PARTNER_DISPLAY_NAMES = {
  LIGHTSPEED: 'Lightspeed'
} as const

export const INTEGRATION_CATEGORIES = {
  POS: 'POS'
} as const

export type PartnerNameType = keyof typeof PartnerName
export type PartnerSlug = (typeof PARTNER_SLUGS)[keyof typeof PARTNER_SLUGS]

/**
 * Helper to get partner name in lowercase (for API comparisons)
 */
export const getPartnerNameLowercase = (partnerName: PartnerName): string => {
  return partnerName.toLowerCase()
}

/**
 * Helper to check if a partner name matches
 */
export const isPartner = (name: string, partner: PartnerName): boolean => {
  return name.toLowerCase() === partner.toLowerCase()
}
